$(document).ready(() => {
    // Scroll to first form error
    const error = $('ul.errorlist')[0];
    if ($(error).length) {
        $('html, body').animate({ scrollTop: $(error).offset().top - 80 }, 700, 'swing');
    }
});

// Add class to form fields to animate labels
// Using event delegation to support dynamically inserted elements (e.g., HTMX swaps)
const formFieldSelector = '.textarea textarea, .textinput input, .emailinput input, .numberinput input, .urlinput input, .dateinput input, .datetimeinput input';

console.log('form-label.js loaded');

$(document).on('focus', formFieldSelector, (e) => {
    console.log('focus event triggered', e.currentTarget);
    console.log('parent element:', $(e.currentTarget).parent());
    $(e.currentTarget).parent().addClass('active');
});

$(document).on('blur', formFieldSelector, (e) => {
    console.log('blur event triggered', e.currentTarget);
    if (!$(e.currentTarget).val()) {
        $(e.currentTarget).parent().removeClass('active');
    }
});
